import * as React from 'react'

import { Checkbox } from '~/components/checkbox/Checkbox'
import { InlineMessage } from '~/components/inline-message/InlineMessage'
import { Label } from '~/components/label/Label'
import { RadioButton } from '~/components/radio-button/RadioButton'
import { cn } from '~/styled'

import { Description } from './FieldDescription'

type InlineFieldWrapperProps = {
  className?: string
  error?: string
  label: string
  required?: boolean
  align?: 'start' | 'center'
  direction?: 'row' | 'reverse'
  description?: string
}

export const InlineFieldWrapper = ({
  align = 'start',
  children,
  className,
  description,
  direction = 'row',
  error,
  label,
  required
}: React.PropsWithChildren<InlineFieldWrapperProps>) => (
  <div className={className}>
    <Label
      align={align}
      direction={direction}
      required={required}
      type="inline"
    >
      {React.Children.map(children, (child: any) => (
        <div
          className={cn(
            direction === 'reverse' && 'ml-3',
            direction === 'row' && 'mr-3',
            (child?.type === Checkbox || child?.type === RadioButton) &&
              child?.props?.size !== 'lg' &&
              'translate-y-1'
          )}
        >
          {child}
        </div>
      ))}
      {label}
    </Label>
    {error && <InlineMessage className="mt-2">{error}</InlineMessage>}
    {description && (
      <Description
        className={cn(
          'mt-2',
          direction === 'reverse' && 'mr-7',
          direction === 'row' && 'ml-7'
        )}
      >
        {description}
      </Description>
    )}
  </div>
)

InlineFieldWrapper.displayName = 'InlineFieldWrapper'
